<template>
  <div class="profile-image">
    <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
      <h3 v-translate>Drop files to upload</h3>
    </div>
    <div class="avatar-upload" v-show="!edit">
      <div class="text-center p-2">
        <label for="file">
          <img :src="files.length ? files[0].url : (profilePicture ? 'https://www.gravatar.com/avatar/default?s=200&r=pg&d=mm' : 'https://via.placeholder.com/200/?text=The%20Picture')"  :class="profilePicture ? 'rounded-circle' : 'free-aspect-ratio'" />
          <h4 class="pt-2"><translate>or</translate><br/><translate>Drop files anywhere to upload</translate></h4>
        </label>
      </div>
      <div class="text-center p-2">
        <file-upload extensions="gif,jpg,jpeg,png,webp" accept="image/png,image/gif,image/jpeg,image/webp" name="file" class="btn btn-secondary" :post-action="$appConfig.api.baseUrl + 'files'" :headers="authHeaders" :drop="!edit" v-model="files" @input-filter="inputFilter" @input-file="inputFile" ref="upload">
          <translate>Upload Image</translate>
        </file-upload>
      </div>
    </div>
    <div class="avatar-edit" v-show="files.length && edit">
      <div class="avatar-edit-image" v-if="files.length">
        <img ref="editImage" :src="files[0].url" />
      </div>
      <div class="text-center p-4">
        <b-button type="submit" size="md" variant="secondary" @click.prevent="editSave" v-translate>Save</b-button>
        <b-button variant="outline-secondary" size="md" @click.prevent="$refs.upload.clear" v-translate>Cancel</b-button>
      </div>
    </div>
  </div>
</template>
<script>
import Cropper from 'cropperjs'
import FileUpload from 'vue-upload-component'
import vueAuthInstance from '@/services/auth'
export default {
  name: 'ProfilePictureUploader',
  components: {
    FileUpload
  },
  props: {
    profilePicture: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      files: [],
      edit: false,
      cropper: false
    }
  },
  computed: {
    authHeaders() {
      return {
        'Authorization': 'Bearer ' + vueAuthInstance.getToken()
      }
    }
  },
  watch: {
    edit(value) {
      if (value) {
        this.$nextTick(function () {
          if (!this.$refs.editImage) {
            return
          }
          let cropper = new Cropper(this.$refs.editImage, {
            aspectRatio: this.profilePicture ? 1 : null, // 1 / 1 (square)
            viewMode: 1,
            width: 160,
            height: 90,
            minWidth: 256,
            minHeight: 256,
            maxWidth: 400,
            maxHeight: 400
          })
          this.cropper = cropper
        })
      } else if (this.cropper) {
        this.cropper.destroy()
        this.cropper = false
      }
    }
  },
  methods: {
    editSave() {
      this.edit = false

      let oldFile = this.files[0]

      let binStr = atob(this.cropper.getCroppedCanvas().toDataURL(oldFile.type).split(',')[1])
      let arr = new Uint8Array(binStr.length)
      for (let i = 0; i < binStr.length; i++) {
        arr[i] = binStr.charCodeAt(i)
      }

      let file = new File([arr], oldFile.name, { type: oldFile.type })

      this.$refs.upload.update(oldFile.id, {
        file,
        type: file.type,
        size: file.size,
        active: true
      })
      console.log(this.$refs.upload.response)
    },
    alert(message) {
      alert(message)
    },
    inputFile(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        this.$nextTick(function () {
          this.edit = true
        })
      }
      if (!newFile && oldFile) {
        this.edit = false
      }
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // catch the server response
        if (newFile.xhr.status === 201) {
          this.$emit('updateProfileImage', newFile.response.full_path)
        }
        console.log('response', newFile.response)
        if (newFile.xhr) {
          // catch the server status response
          console.log('status', newFile.xhr.status)
        }
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
          this.alert('Your choice is not a picture')
          return prevent()
        }
      }

      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.url = ''
        let URL = window.URL || window.webkitURL
        if (URL && URL.createObjectURL) {
          newFile.url = URL.createObjectURL(newFile.file)
        }
      }
    }
  }
}

</script>
<style>
.profile-image .avatar-upload .rounded-circle {
  width: 200px;
  height: 200px;
}
.profile-image .avatar-upload .free-aspect-ratio {
  width: auto;
  height: auto;
  max-width: 200px;
  max-height: 200px;
}

.profile-image .text-center .btn {
  margin: 0 .5rem
}

.profile-image .avatar-edit-image {
  height: 400px
}


.profile-image .drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: .6;
  text-align: center;
  background: #000;
}

.profile-image .drop-active h3 {
  margin: -.5em 0 0;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 40px;
  color: #fff;
  padding: 0;
}

</style>
